import { useCallback, useState } from "react";
import { SelectWrapper } from "./SelectWrapper";
import * as Icons from 'react-icons/bs';
import { OptionType } from "../../types";

export type SelectPanelProps = {
    title: string,
    options: OptionType[],
    values: OptionType[],
    onChange: (newValue: OptionType[]) => void,
}

export const SelectPanel = ({
    title,
    options,
    values,
    onChange
}: SelectPanelProps) => {
    const [selectedValue, setSelectedValue] = useState<OptionType | undefined>();

    const [focusedValue, setFocusedValue] = useState<OptionType | undefined>();

    const handleAddOption = useCallback(() => {
        if (!selectedValue) return;
        if (values.find(v => v.value === selectedValue.value)) return;
        onChange([...values, selectedValue]);

    }, [selectedValue, values, onChange]);

    const handleRemoveOption = useCallback(() => {
        if (!focusedValue) return;
        onChange(values.filter(v => v.value !== focusedValue.value));
        setFocusedValue(undefined);
    }, [focusedValue, onChange, values]);
    

    return (
        <div className='advanced-search-panel select'>
            <div className='advanced-search-panel-title'>
                {title}
            </div>
            <div className='advanced-search-panel-content'>
                <SelectWrapper
                    value={selectedValue}
                    onChange={(newValue) => setSelectedValue(newValue || undefined)}
                    options={options}
                />
                <div className='advanced-search-panel-options'>
                    <div className='advanced-search-panel-options-inner'>
                        {
                            values.map(v =>
                                <div
                                    key={v.value}
                                    className={`advanced-search-panel-label ${focusedValue?.value === v.value ? 'active' : ''}`}
                                    onClick={() => setFocusedValue(v)}
                                >
                                    {v.label}
                                </div>
                            )
                        }
                    </div>
                    <div className='advanced-search-panel-options-actions'>
                        <div className='advanced-search-panel-options-action'>
                            <Icons.BsPlus
                                className={!selectedValue || values.find(v => v.value === selectedValue.value) ? 'disabled action-button' : 'action-button'}
                                onClick={handleAddOption}
                            />
                        </div>
                        <div className='advanced-search-panel-options-action'>
                            <Icons.BsDash
                                className={!focusedValue ? 'disabled action-button' : 'action-button'}
                                onClick={handleRemoveOption}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}